import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chat-share"
export default class extends Controller {
  static targets = ["urlInput", "copyButton", "copyIcon", "copyLabel"]

  async copy(event) {
    event.preventDefault()

    try {
      await navigator.clipboard.writeText(this.urlInputTarget.value)
      this.showCopiedFeedback()
    } catch (err) {
      console.error('Failed to copy share URL:', err)
    }
  }

  showCopiedFeedback() {
    const originalIcon = this.copyIconTarget.innerHTML
    const originalLabel = this.copyLabelTarget.textContent

    // Show checkmark
    this.copyIconTarget.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="size-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
      </svg>
    `
    this.copyLabelTarget.textContent = "Copied!"

    // Highlight URL
    this.urlInputTarget.select()

    // Reset after 2 seconds
    setTimeout(() => {
      this.copyIconTarget.innerHTML = originalIcon
      this.copyLabelTarget.textContent = originalLabel
      this.urlInputTarget.blur()
    }, 2000)
  }
}
